import { IconButton } from "@mui/material";

import RemoveIcon from "@mui/icons-material/Remove";

import { adjustButtonSx } from "./CraneCellAdjustButton";
import { AdjustmentArgs } from "../../types";
import { useCraneDriver } from "../../CraneDriverProvider";

export const CraneCellDecreaseButton = ({
  args,
  disabled,
}: {
  args: AdjustmentArgs;
  disabled: boolean;
}) => {
  const { decrementMass } = useCraneDriver();
  return (
    <IconButton
      className="material-rm-btn"
      onClick={() => {
        decrementMass(args);
      }}
      sx={adjustButtonSx}
      disabled={disabled}
    >
      <RemoveIcon />
    </IconButton>
  );
};
